import { render, staticRenderFns } from "./ScoreFeedback.vue?vue&type=template&id=27da07f7&scoped=true"
import script from "./ScoreFeedback.vue?vue&type=script&lang=js"
export * from "./ScoreFeedback.vue?vue&type=script&lang=js"
import style0 from "./ScoreFeedback.vue?vue&type=style&index=0&id=27da07f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27da07f7",
  null
  
)

export default component.exports